import { render, staticRenderFns } from "./HomeCarouselMobile.vue?vue&type=template&id=85a8d490&scoped=true&"
import script from "./HomeCarouselMobile.vue?vue&type=script&lang=js&"
export * from "./HomeCarouselMobile.vue?vue&type=script&lang=js&"
import style0 from "./HomeCarouselMobile.vue?vue&type=style&index=0&id=85a8d490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a8d490",
  null
  
)

component.options.__file = "HomeCarouselMobile.vue"
export default component.exports